import { IStudyGroup } from "models/study-group";

export const studyGroups: IStudyGroup[] = [
    {
        name: 'model_vel',
        studyNames: ['MODEL_VEL']
    },
    {
        name: 'experiment1',
        studyNames: ['EXP01']
    },
    {
        name: 'experiment2',
        studyNames: ['EXP02']
    },
    {
        name: 'experiment3',
        studyNames: ['EXP03']
    },
    {
        name: 'experiment4',
        studyNames: ['EXP04']
    },
    {
        name: 'experiment5',
        studyNames: ['EXP05']
    },
    {
        name: 'experiment6',
        studyNames: ['EXP06']
    },
    {
        name: 'experiment7',
        studyNames: ['EXP07']
    },
    {
        name: 'experiment8',
        studyNames: ['EXP08']
    },
    {
        name: 'experiment9',
        studyNames: ['EXP09']
    },
    {
        name: 'experiment10',
        studyNames: ['EXP10']
    },
    {
        name: 'obo',
        studyNames: ['_Overbought/Oversold Inline', '_Overbought / Oversold Individual']
    },
    {
        name: 'lawr',
        studyNames: ['_LAWR']
    },
    {
        name: 'riskreward',
        studyNames: ['_R3M2R25', '_TJ1', '_R1M2R25', '_B2X5']
    },
];